
export const GetInstructors = () => {
  return fetchApi("/instructors/")
}

export const CreateInstructor = (subject) => {
  return fetchApi('/instructors/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const UpdateInstructor = (id, subject) => {
  return fetchApi(`/instructors/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(subject)
  });
}

export const DeleteInstructor = (id) => {
  return fetchApi(`/instructors/${id}`, { method: 'DELETE' })
}